import { useState } from 'react';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import ListActionBar from 'src/components/ListActionBar';
import { readFilterParams, useFilterParams } from 'src/hooks/filterParams';
import { useInfiniteWin32AppFileSets } from 'src/hooks/wdac';
import { EXPANDED_ROWS_LIMIT } from 'src/constants/table';
import CompactDataTable from 'src/components/CompactDataTable';
import Win32FileSetModal from '../../Win32FileSetModal';
import { DEFAULT_FILE_SET_FILTERS, FILE_SET_FILTER_OPTIONS, FILE_SETS_COLUMNS } from './constants';

const CLOSED_MODAL = { open: false, fileSetId: null };

const FileSetsTab = () => {
  const { appId } = useParams();
  const [searchValue, setSearchValue] = useState('');
  const [filters, setFilters] = useState(
    () => readFilterParams(DEFAULT_FILE_SET_FILTERS) ?? DEFAULT_FILE_SET_FILTERS,
  );
  const [modal, setModal] = useState(CLOSED_MODAL);

  useFilterParams(filters);

  const fileSetsQuery = useInfiniteWin32AppFileSets({
    globalApplicationVersionId: appId,
    statuses: filters.statuses,
    search: searchValue,
    limit: EXPANDED_ROWS_LIMIT,
  });

  const rows = fileSetsQuery.data?.pages?.flatMap(page => page.results || []) || [];
  const totalCount = fileSetsQuery.data?.pages?.[0]?.totalCount;

  const [sentryRef] = useInfiniteScroll({
    loading: fileSetsQuery.isFetchingNextPage,
    hasNextPage: !!fileSetsQuery.hasNextPage,
    onLoadMore: fileSetsQuery.fetchNextPage,
    rootMargin: '0px 0px 400px 0px',
  });

  return (
    <Box>
      <ListActionBar
        onSearch={setSearchValue}
        searchPlaceholder="Search by file set hash..."
        filters={filters}
        onFilterChange={setFilters}
        filterOptions={FILE_SET_FILTER_OPTIONS}
        filterChips
        filterButtonCount={totalCount}
      />
      <CompactDataTable
        columns={FILE_SETS_COLUMNS}
        rows={rows}
        isLoading={fileSetsQuery.isLoading}
        isFetching={fileSetsQuery.isFetching}
        lastElementRef={sentryRef}
        searchValue={searchValue}
        onRowClick={row => setModal({ open: true, fileSetId: row.id })}
      />

      <Win32FileSetModal
        open={modal.open}
        onClose={() => setModal(CLOSED_MODAL)}
        globalApplicationVersionId={appId}
        fileSetId={modal.fileSetId}
      />
    </Box>
  );
};

export default FileSetsTab;
